import React, { useState } from 'react';

interface CredentialsSetupProps {
  walletAddress: string;
  onCredentialsComplete: () => void;
}

const CredentialsSetup: React.FC<CredentialsSetupProps> = ({ walletAddress, onCredentialsComplete }) => {
  const [hlApiKey, setHlApiKey] = useState('');
  const [fundingWallet, setFundingWallet] = useState('');
  const [agentWallet, setAgentWallet] = useState('');
  const [persistEnabled, setPersistEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [userId, setUserId] = useState('');
  const [userIdError, setUserIdError] = useState('');

  const validateUserId = (id: string) => {
    if (id.length < 8) return "Minimum 8 characters required";
    if (!/[a-zA-Z]/.test(id)) return "Must contain letters";
    if (!/[0-9]/.test(id)) return "Must contain numbers";
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(id)) return "Must contain symbols";
    return "";
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validate User ID
    const userIdValidation = validateUserId(userId);
    if (userIdValidation) {
      setUserIdError(userIdValidation);
      setLoading(false);
      return;
    }
      setUserIdError('');
    
    try {
      // Call your backend API (same as Streamlit)
      const response = await fetch('/api/credentials/setup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
            'X-User-ID': userId,
        },
        body: JSON.stringify({
          api_key: hlApiKey,
          funding_wallet: fundingWallet,
          agent_wallet: agentWallet,
          persist_enabled: persistEnabled,
          wallet_address: walletAddress,
            user_id: userId,
        })
      });
      
      if (!response.ok) {
        throw new Error('Failed to save credentials');
      }
      
      // Clear sensitive data
      setHlApiKey('');
      setFundingWallet('');
      setAgentWallet('');
        setUserId('');
      
        localStorage.setItem("userSessionId", userId);
      onCredentialsComplete();
    } catch (err) {
      setError('Failed to save credentials: ' + (err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="credentials-setup">
      <h2>Setup HyperLiquid Credentials</h2>
      <p>Enter your HyperLiquid trading credentials</p>
      
      {error && <div className="error">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>HyperLiquid API Key</label>
          <input
            type="password"
            value={hlApiKey}
            onChange={(e) => setHlApiKey(e.target.value)}
            placeholder="0x... (private key)"
            className="form-input"
            required
          />
        </div>
        
        <div className="form-group">
          <label>Funding Wallet Address</label>
          <input
            type="text"
            value={fundingWallet}
            onChange={(e) => setFundingWallet(e.target.value)}
            placeholder="0x... (funding wallet)"
            className="form-input"
            required
          />
        </div>
        
        <div className="form-group">
          <label>Agent Wallet Address</label>
          <input
            type="text"
            value={agentWallet}
            onChange={(e) => setAgentWallet(e.target.value)}
            placeholder="0x... (agent wallet)"
            className="form-input"
            required
          />
        </div>

          <div className="form-group">
            <label>User ID (Trading Session)</label>
            <input
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="trader123!@# (min 8 chars, letters+numbers+symbols)"
              className="form-input"
              required
            />
            {userIdError && <div className="error-text">{userIdError}</div>}
          </div>

        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={persistEnabled}
              onChange={(e) => setPersistEnabled(e.target.checked)}
              className="checkbox-input"
            />
            <span className="checkbox-text">
              🔐 Securely store credentials for 30 days (encrypted) - Enables auto-restart
            </span>
          </label>
        </div>
        
        <button type="submit" className="btn" disabled={loading}>
          {loading ? 'Setting up...' : 'Save Credentials'}
        </button>
      </form>
    </div>
  );
};

export default CredentialsSetup;
